import ManageUsers from './UsersList'
import ManageUser from './User'
import CreateUser from './CreateUser'

export default [{
  path: '/manage/users',
  name: 'ManageUsers',
  component: ManageUsers,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Manage Users'}
}, {
  path: '/manage/user/create',
  name: 'CreateUser',
  component: CreateUser,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Create User'}
}, {
  path: '/manage/user/:id',
  name: 'ManageUser',
  component: ManageUser,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Manage User'}
}
]



// WEBPACK FOOTER //
// ./src/pages/manageUsers/router.js